export const enum ApplicableStatutoryAuthorities {
  Section10 = 'Section 10 of the Rivers and Harbors Act of 1899 (33 U.S.C. 403)',
  Section103 = 'Section 103 of the Marine Protection, Research, and Sanctuaries Act of 1972, as amended (33 U.S.C. 1413)',
  Section404 = 'Section 404 of the Clean Water Act (33 U.S.C. 1344)',
}

export const enum ContactsFormNames {
  AgentAuthorization = 'Agent Authorization',
  RightOfEntry = 'Right of Entry',
}

export const enum JPAContactTypes {
  BasicContact = 10,
}

export const enum ContactTypes {
  AdjoiningPropertyOwner = 'Adjoining Property Owner',
  Agent = 'Agent',
  Applicant = 'Applicant',
  BasicContact = JPAContactTypes.BasicContact,
  PropertyOwner = 'Property Owner',
  Reporter = 'Reporter',
  SuspectContractor = 'Suspect - Contractor',
  SuspectOther = 'Suspect - Other',
  SuspectPropertyOwner = 'Suspect - Property Owner',
  Witness = 'Witness',
}

export const enum ErrorMessages {
  FileEmpty = 'File is empty. Please select another file.',
  FileExists = 'This file name has already been used. Please rename file or select another.',
  FileNameInvalidCharacters = 'File name contains invalid characters. Please rename file. File name can only contain alphanumeric characters, whitespace, and the following special characters: !, -, _, ., (, ), &, $, @, =, ;, +, ,',
  FileNameTooLong = 'File name is exceeds character limit (> 1024 characters). Please shorten the file name.',
  FileTooLarge = 'File is too large (> 100MB). Please compress file, parse into separate files, or select another file.',
  GDBFileMissing = 'Geodatabase File Upload: Please select a file to upload',
  GeometryBoundaryFailure = 'To correct the aquatic resource, remove this item from the table, correct the geometry, and upload it again.',
  GreatThanZero = 'Value must be more than 0',
  Invalid = 'Field is invalid',
  InvalidCharacters = 'Invalid character(s) have been removed.',
  InvalidCoordinates = 'File contained invalid values. Please enter the values manually for the highlighted fields.',
  InvalidDistrict = 'A USACE regulatory district could not be determined for this location. Please update your coordinates and try again.',
  InvalidDistrictCsv = 'A USACE regulatory district could not be determined for all CSV coordinates. Please verify all coordinates within the CSV or XLSX and try again.',
  InvalidEmail = 'The provided email is not valid',
  InvalidHeaders = 'File contained invalid header values. Please verify the headers of the CSV file and re-upload.',
  InvalidLatitudeFormat = 'Latitude format is incorrect. Must be +-XX.XXXXXX and include at least 6 decimal places.',
  InvalidLatitudeRange = 'Latitude must be between 0 and 90',
  InvalidLongitudeFormat = 'Longitude format is incorrect. Must be +-XXX.XXXXXX and include at least 6 decimal places.',
  InvalidLongitudeRange = 'Longitude must be between -180 and 0',
  InvalidValue = 'Value is not valid',
  MultiSelectOption = 'Please select at least one option',
  OverTotalFileCount = 'Only 50 files can be uploaded per save. Please hit "Save Progress" to upload your files and try again.',
  OverTotalFileLimit = 'Only 500MB of files can be uploaded per save. Please hit "Save Progress" to upload your files and try again.',
  Required = 'Field is required',
  RequiredMissing = 'Required value is missing',
  RestrictedChars = 'Only letters, numbers, dashes, periods, commas, apostrophes, number signs, and spaces are allowed.',
  SelectOption = 'Please select an option',
  UploadNotice = 'Individual files cannot exceed 100MB, and in total cannot exceed 500MB per save.',
}

export const enum FileTypes {
  Request = 'Request',
  Resource = 'Resource',
  Template = 'Template',
}

export const enum GeometryTypes {
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  MultiPoint = 'MultiPoint',
  MultiPolygon = 'MultiPolygon',
  Point = 'Point',
  Polygon = 'Polygon',
}

export const enum ImpactsActivity {
  ConversionWatersType = 'Conversion of waters type (forested wetland to emergent wetland, stream to lake)',
  DischargeDredgedMaterial = 'Discharge of dredged material',
  DischargeFillMaterial = 'Discharge of fill material',
  DredgingSection = 'Dredging (Section 10)',
  EcologicalRestoration = 'Ecological restoration',
  Other = 'Other (Aquaculture, Work, Aerial or Submarine cable crossings)',
  Removal = 'Removal (Sec 10 structures)',
  Structure = 'Structure (Sec 10 only)',
  TransportDredgedMaterial = 'Transport of dredged material (Sec 103)',
}

export const enum ImpactsResourceType {
  HarborOcean = 'Harbor/Ocean',
  Lake = 'Lake',
  NonTidalWetland = 'Non-Tidal Wetland',
  Pond = 'Pond',
  RiverStream = 'River/Stream',
  TidalWetland = 'Tidal Wetland',
  Other = 'Other',
}

export const enum IPACSupportedFootprintGeometryType {
  Polygon = 'Polygon',
  MultiPolygon = 'MultiPolygon',
}

export const enum LoadingMessages {
  Default = 'Loading...',
  Processing = 'Processing file. This may take a moment...',
  SaveRequest = 'Saving Request...',
  SubmitRequest = 'Submitting Request...',
  UploadFile = 'Uploading files. This may take a moment...',
  ValidateGeometry = 'Validating Geometry Location...',
}

export const enum MitigationTypes {
  AdvancedPermitteeResponsible = 'Advanced Permittee Responsible Mitigation',
  InLieuFee = 'In-lieu Fee',
  MitigationBank = 'Mitigation Bank',
}

export const enum PhoneTypes {
  Business = 'Business',
  Mobile = 'Mobile',
  Primary = 'Primary',
  Residence = 'Residence',
  Secondary = 'Secondary',
}

export const enum PreAppRequestTypes {
  MitigationBankOrFee = 'Mitigation bank or in-lieu fee',
  NeedAdvice = 'I need advice on what type of permit is applicable',
  ScopingResponse = 'Scoping response for environmental compliance (NEPA, state/local environmental scoping requirements, etc.)',
  StandardPermit = 'Standard permit',
}

export const enum ProfileRoles {
  Agent = 'Agent',
  Anonymous = 'Anonymous',
  Applicant = 'Applicant',
  Developer = 'Developer',
  ExternalAgency = 'External Agency',
  HelpDesk = 'Help Desk',
  USACERegulator = 'USACE Regulator',
}

export const enum ResourceFiles {
  ARBulkUploadCSV = 'Aquatic_Resource_Bulk_Upload_Template.csv',
  ARBulkUploadGDBTemplate = 'Aquatic_Resource_Bulk_Upload_10092025.gdb.zip',
  ARBulkUploadGuide = 'Aquatic_Resource_Bulk_Upload_Guide.pdf',
  ARGeodatabaseQuickGuide = 'Aquatic Resource Geodatabase Quick Guide V2.pdf',
  ARDRFigureExample = 'ARDR_Example_Figures.ppkx',
  ARDRRecommendedMinimumStandards = 'ARDR Recommended Minimum Standards-21JUL25.pdf',
  AdditionalInformation = 'JD_Additional_info.pdf',
  AppendixA1 = 'Appx_A1_Property_Owners.pdf',
  AppendixA2 = 'Appx_A2_Adjoining_Property_Owners.pdf',
  AppendixB = 'Appx_B_Aquatic_Resources.pdf',
  AppendixC = 'Appx_C_Impacts.pdf',
  AppendixD1 = 'Appx_D1_MB_ILF.pdf',
  AppendixD2 = 'Appx_D2_PRM.pdf',
  AppendixE = 'Appx_E_Dredging.pdf',
  AppendixF = 'Appx_F_Shoreline_Stabilization.pdf',
  AppendixG = 'Appx_G_Pile_Driving.pdf',
  AppendixH = 'Appx_H_Supporting_Files.pdf',
  PropertyOwnerBulkUploadCSV = 'Property_Owner_Bulk_Upload_CSV_Template.csv',
  AdjPropertyOwnerBulkUploadCSV = 'Adjoining_Property_Owner_Bulk_Upload_CSV_Template.csv',
  DistrictList = 'JPA_Districts_14MAY2024.pdf',
  DistrictSpecificInfo = 'District_Specific_Information_14MAY2024.pdf',
  Eng4345 = 'ENG_4345_Individual_Permit.pdf',
  Eng4345ProjectInfo = 'IP_Additional_Info.pdf',
  Eng6082 = 'ENG_6082_Nationwide_Permit.pdf',
  Eng6247 = 'ENG_6247_Jurisdictional_Determination.pdf',
  Eng6284 = 'ENG_6284_Violation_Complaint.pdf',
  Eng6286 = 'ENG_6286_Pre_Application.pdf',
  Eng6294 = 'ENG_6294_Right_Of_Entry.pdf',
  Eng6295 = 'ENG_6295_Agent_Authorization.pdf',
  GNSSGuide = 'GNSS Guide for Mapping Aquatic Resources-21JUL25.pdf',
  ImpactBulkUploadCSV = 'Impact_Bulk_Upload_CSV_Template.csv',
  ImpactMitBulkUploadGuide = 'Impacts_Mitigation_Bulk_Upload_Guide.pdf',
  LoginGovHelpGuide = 'Login_gov_guide.pdf',
  MitBankIlfBulkUploadCSV = 'Mitigation_Bank_Inlieu_Fee_Bulk_Upload_CSV_Template.csv',
  PRMBulkUploadCSV = 'Permittee_Responsible_Mitigation_Bulk_Upload_CSV_Template.csv',
  Reg101FreqUsedTerms = '20240618_RRS Regulatory Terms_Final.pdf',
  SampleDrawingBankStabilizationBioEng = 'Sample Drawing_Bank Stabilization (Bioengineered) 20240515.pdf',
  SampleDrawingBankStabilizationRipRap = 'Sample Drawing_Bank Stabilization (Riprap)_20240515.pdf',
  SampleDrawingCulvert = 'Sample Drawing_Culvert_20240318.pdf',
  SampleDrawingDock = 'Sample Drawing_Dock_20240226.pdf',
  SampleDrawingStream = 'Sample Drawing_Stream Crossing_20240304.pdf',
  SampleDrawingWetlandHouse = 'Sample Drawing_Wetland Fill for House_20240514.pdf',
  SampleDrawingWetlandRoad = 'Sample Drawing_Wetland Fill for Road_20240426.pdf',
}

export const enum RequestStatus {
  Acknowledged = 'Acknowledged',
  AdditionalInformationRequested = 'Additional Information Requested',
  Assigned = 'Assigned',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Draft = 'Draft',
  Insufficient = 'Insufficient',
  LeadAgencyChanged = 'Lead Agency Changed',
  NotApproved = 'Not Approved',
  ReRouted = 'Re-Routed',
  Resubmitted = 'Resubmitted',
  Revision = 'Revision',
  Submitted = 'Submitted',
  UnderRevision = 'Under Revision',
  WithdrawnByApplicant = 'Withdrawn by Applicant',
  WithdrawnByUSACE = 'Withdrawn By USACE',
}

export const enum RequestType {
  ActivityBasedNoPermitRequired = 'No Permit Required (Activity Based)',
  ApplicationForDAPermit = 'Application for Department of the Army (DA) Permit (ENG 4345)',
  AquaticResourceDelineationReport = 'Aquatic Resource Delineation Report',
  AquaticResourceDelineationReportAndInventory = 'Aquatic Resource Delineation Report and Aquatic Resource Inventory',
  AquaticResourceDelineationReportAndJurisdictionalDetermination = 'Aquatic Resource Delineation Report and Jurisdictional Determination',
  DelineationReport = 'Delineation Report',
  DelineationReportAndJurisdictionalDetermination = 'Delineation Report and Jurisdictional Determination',
  IndividualPermit = 'Individual Permit (ENG 4345)',
  JurisdictionalDetermination = 'Jurisdictional Determination',
  NationwidePermit = 'Nationwide Permit (ENG 6082)',
  NonPreconstructionNotification = 'No Pre-construction Notification Required (Nationwide Permits)',
  NoPermitRequired = 'No Permit Required',
  PermitApplication = 'Application for Department of the Army (DA) Permit',
  PreApplication = 'Pre-application/Project Scoping',
  PreconstructionNotification = 'Preconstruction Notification (PCN) (ENG 6082)',
  ViolationComplaint = 'Violation Complaint',
}

export const RequestTypeIds = {
  AquaticResourceDelineationReport: 1,
  JurisdictionalDetermination: 2,
  ApplicationForDAPermit: 3,
  PreconstructionNotification: 4,
  PreApplication: 5,
  ViolationComplaint: 6,
  DelineationReport: 7,
  IndividualPermit: 8,
  NationwidePermit: 9,
  NoPermitRequired: 10,
  NonPreconstructionNotification: 11,
  PermitApplication: 12,
  ActivityBasedNoPermitRequired: 13,
};

export const RequestTypeStringIds = Object.keys(RequestTypeIds).reduce(
  (acc, key) => {
    acc[key] = RequestTypeIds[key as keyof typeof RequestTypeIds].toString();
    return acc;
  },
  {} as { [key: string]: string }
);

// Map Request Type IDs to Request Type Strings for Text Display in UI
export const RequestTypeStrings: {
  [key: string]: string;
} = {
  [RequestTypeIds.AquaticResourceDelineationReport]:
    'Submit an Aquatic Resource Delineation Report and Aquatic Resource Inventory',
  [RequestTypeIds.JurisdictionalDetermination]: 'Request a Jurisdictional Determination',
  [RequestTypeIds.ApplicationForDAPermit]: RequestType.ApplicationForDAPermit,
  [RequestTypeIds.PreconstructionNotification]: RequestType.PreconstructionNotification,
  [RequestTypeIds.PreApplication]: RequestType.PreApplication,
  [RequestTypeIds.ViolationComplaint]: RequestType.ViolationComplaint,
  [RequestTypeIds.DelineationReport]: 'Submit a WOTUS Delineation Report and Aquatic Resource Inventory',
  [RequestTypeIds.IndividualPermit]: RequestType.IndividualPermit,
  [RequestTypeIds.NationwidePermit]: RequestType.NationwidePermit,
  [RequestTypeIds.NoPermitRequired]: RequestType.NoPermitRequired,
  [RequestTypeIds.NonPreconstructionNotification]: RequestType.NonPreconstructionNotification,
  [RequestTypeIds.PermitApplication]: RequestType.PermitApplication,
  [RequestTypeIds.ActivityBasedNoPermitRequired]: RequestType.ActivityBasedNoPermitRequired,
};

// Map Request Type IDs to Request Type Strings that matches BE enums
export const RequestTypeStringsLookup: {
  [key: string]: string;
} = {
  [RequestTypeIds.AquaticResourceDelineationReport]: RequestType.AquaticResourceDelineationReport,
  [RequestTypeIds.JurisdictionalDetermination]: RequestType.JurisdictionalDetermination,
  [RequestTypeIds.ApplicationForDAPermit]: RequestType.ApplicationForDAPermit,
  [RequestTypeIds.PreconstructionNotification]: RequestType.PreconstructionNotification,
  [RequestTypeIds.PreApplication]: RequestType.PreApplication,
  [RequestTypeIds.ViolationComplaint]: RequestType.ViolationComplaint,
  [RequestTypeIds.DelineationReport]: RequestType.DelineationReport,
  [RequestTypeIds.IndividualPermit]: RequestType.IndividualPermit,
  [RequestTypeIds.NationwidePermit]: RequestType.NationwidePermit,
  [RequestTypeIds.NoPermitRequired]: RequestType.NoPermitRequired,
  [RequestTypeIds.NonPreconstructionNotification]: RequestType.NonPreconstructionNotification,
  [RequestTypeIds.PermitApplication]: RequestType.PermitApplication,
  [RequestTypeIds.ActivityBasedNoPermitRequired]: RequestType.ActivityBasedNoPermitRequired,
};

export const RequestMap = {
  [RequestTypeIds.AquaticResourceDelineationReport]: 'jdRequests',
  [RequestTypeIds.JurisdictionalDetermination]: 'jdRequests',
  [RequestTypeIds.ApplicationForDAPermit]: 'permits',
  [RequestTypeIds.PreconstructionNotification]: 'permits',
  [RequestTypeIds.PreApplication]: 'preApplications',
  [RequestTypeIds.ViolationComplaint]: 'violationComplaints',
  [RequestTypeIds.NoPermitRequired]: 'noPermitRequireds',
  [RequestTypeIds.NonPreconstructionNotification]: 'nonPCNRequests',
  [RequestTypeIds.PermitApplication]: 'permits',
  [RequestTypeIds.ActivityBasedNoPermitRequired]: 'noPermitRequireds',
};

export const enum NprResultTypes {
  JurisdictionalDetermination = 'Jurisdictional Determination',
  NprExemption = '404(f) Exemption',
  NprLetter = 'No Permit Required',
  PermitRequired = 'Permit Required',
  PreApplication = RequestType.PreApplication,
}

export const enum PcnResultTypes {
  ContactDistrict = 'Contact District',
  NonPcnLetter = 'No PCN Required',
  PcnRequired = 'PCN Required',
  PreApplication = RequestType.PreApplication,
}

export const enum PermitTypes {
  GeneralPermit = 'General Permit',
  LetterOfPermission = 'Letter of Permission',
  StandardPermit = 'Standard Permit',
}

export const enum TemplateFiles {
  Amended2023RuleGDB = 'Amended_2023Rule.gdb.zip',
  PostSackettGDB = 'Pre2015_Post_Sackett.gdb.zip',
  ProjectLocationGDBTemplate = 'ProjectArea_BLANK.gdb.zip',
  PropertyOwnerBulk = 'Property_Owner_Template_v1.xlsx',
}

export const enum ErrorStates {
  Active = 'active',
  ActiveComplete = 'activecomplete',
  ActiveError = 'activeerror',
  Complete = 'complete',
  Error = 'error',
}

export const RequestStatusStyles = {
  [RequestStatus.Acknowledged]: 'acknowledged',
  [RequestStatus.AdditionalInformationRequested]: 'additional-info-requested',
  [RequestStatus.Assigned]: 'assigned',
  [RequestStatus.Cancelled]: 'cancelled',
  [RequestStatus.Completed]: 'completed',
  [RequestStatus.Draft]: 'draft',
  [RequestStatus.Insufficient]: 'insufficient',
  [RequestStatus.LeadAgencyChanged]: 'lead-agency-changed',
  [RequestStatus.NotApproved]: 'not-approved',
  [RequestStatus.ReRouted]: 're-routed',
  [RequestStatus.Resubmitted]: 'resubmitted',
  [RequestStatus.Revision]: 'revision',
  [RequestStatus.Submitted]: 'submitted',
  [RequestStatus.UnderRevision]: 'under-revision',
  [RequestStatus.WithdrawnByApplicant]: 'withdrawn-by-applicant',
  [RequestStatus.WithdrawnByUSACE]: 'withdrawn-by-usace',
};

export const ResponseStatuses = {
  AlreadyExist: 'Already Exist',
  DoesNotExist: 'Does Not Exist',
  Error: 'Error',
  Failed: 'Failed',
  NoUserFound: 'NoUser Found',
  Success: 'Success',
  SuccessNoResult: 'Success No Result',
  SuccessWithWarning: 'Success With Warning',
  UserFound: 'User Found',
  ValidationFailed: 'Validation Failed',
  Warning: 'Warning',
  PartialSuccess: 'Partial Success',
};

export const UserPermissions = {
  Owner: 'Owner',
  ReadWrite: 'Write',
  ReadOnly: 'Read',
};

export const RoleMap = {
  [UserPermissions.Owner]: 'PROJECT OWNER',
  [UserPermissions.ReadWrite]: 'READ/WRITE',
  [UserPermissions.ReadOnly]: 'READ ONLY',
};

export const AdditionalInfoFilterStatuses = {
  Open: 'Open',
  Closed: 'Closed',
};

export const HelpRequestStatuses = {
  Open: 'Open',
  InProgress: 'In-Progress',
  Completed: 'Completed',
  Closed: 'Closed',
} as const;

//Used for file upload
export const enum StorageScopes {
  ProjectFolder = 'ProjectFolder',
  ProjectAndAllSubFolders = 'ProjectAndAllSubFolders',
}

export enum FileSubFolder {
  Generated = 'Generated',
  AdditionalInformationResponses = 'AdditionalInformationResponses',
}

export enum FileSection {
  Generated = 'Generated',
  AdditionalInformationRequest = 'Additional Information Request',
}

//Used for file download
export const enum StorageReasons {
  AirRequest = 'AIRRequest',
  Project = 'Project',
}

// Enum helper type to get union of enum values
export type EnumValues<T> = T[keyof T];

export const statesData = [
  { stateABBR: 'AL', state: 'Alabama' },
  { stateABBR: 'AK', state: 'Alaska' },
  { stateABBR: 'AZ', state: 'Arizona' },
  { stateABBR: 'AR', state: 'Arkansas' },
  { stateABBR: 'CA', state: 'California' },
  { stateABBR: 'CO', state: 'Colorado' },
  { stateABBR: 'CT', state: 'Connecticut' },
  { stateABBR: 'DE', state: 'Delaware' },
  { stateABBR: 'DC', state: 'District of Columbia' },
  { stateABBR: 'FL', state: 'Florida' },
  { stateABBR: 'GA', state: 'Georgia' },
  { stateABBR: 'HI', state: 'Hawaii' },
  { stateABBR: 'ID', state: 'Idaho' },
  { stateABBR: 'IL', state: 'Illinois' },
  { stateABBR: 'IN', state: 'Indiana' },
  { stateABBR: 'IA', state: 'Iowa' },
  { stateABBR: 'KS', state: 'Kansas' },
  { stateABBR: 'KY', state: 'Kentucky' },
  { stateABBR: 'LA', state: 'Louisiana' },
  { stateABBR: 'ME', state: 'Maine' },
  { stateABBR: 'MD', state: 'Maryland' },
  { stateABBR: 'MA', state: 'Massachusetts' },
  { stateABBR: 'MI', state: 'Michigan' },
  { stateABBR: 'MN', state: 'Minnesota' },
  { stateABBR: 'MS', state: 'Mississippi' },
  { stateABBR: 'MO', state: 'Missouri' },
  { stateABBR: 'MT', state: 'Montana' },
  { stateABBR: 'NE', state: 'Nebraska' },
  { stateABBR: 'NV', state: 'Nevada' },
  { stateABBR: 'NH', state: 'New Hampshire' },
  { stateABBR: 'NJ', state: 'New Jersey' },
  { stateABBR: 'NM', state: 'New Mexico' },
  { stateABBR: 'NY', state: 'New York' },
  { stateABBR: 'NC', state: 'North Carolina' },
  { stateABBR: 'ND', state: 'North Dakota' },
  { stateABBR: 'OH', state: 'Ohio' },
  { stateABBR: 'OK', state: 'Oklahoma' },
  { stateABBR: 'OR', state: 'Oregon' },
  { stateABBR: 'PA', state: 'Pennsylvania' },
  { stateABBR: 'RI', state: 'Rhode Island' },
  { stateABBR: 'SC', state: 'South Carolina' },
  { stateABBR: 'SD', state: 'South Dakota' },
  { stateABBR: 'TN', state: 'Tennessee' },
  { stateABBR: 'TX', state: 'Texas' },
  { stateABBR: 'UT', state: 'Utah' },
  { stateABBR: 'VT', state: 'Vermont' },
  { stateABBR: 'VA', state: 'Virginia' },
  { stateABBR: 'WA', state: 'Washington' },
  { stateABBR: 'WV', state: 'West Virginia' },
  { stateABBR: 'WI', state: 'Wisconsin' },
  { stateABBR: 'WY', state: 'Wyoming' },

  { stateABBR: 'AS', state: 'American Samoa' },
  { stateABBR: 'GU', state: 'Guam' },
  { stateABBR: 'JA', state: 'Johnston Atoll' },
  { stateABBR: 'MP', state: 'Commonwealth of the Northern Mariana Islands' },
  { stateABBR: 'MW', state: 'Midway Islands' },
  { stateABBR: 'PR', state: 'Puerto Rico' },
  { stateABBR: 'VI', state: 'United States Virgin Islands' },
  { stateABBR: 'WK', state: 'Wake Island' },
  { stateABBR: 'BI', state: 'Baker Island' },
  { stateABBR: 'HW', state: 'Howland Island' },
  { stateABBR: 'JI', state: 'Jarvis Island' },
  { stateABBR: 'KR', state: 'Kingman Reef' },
  { stateABBR: 'PY', state: 'Palmyra Atoll' },
] as const;

export const stateAndRegionOptions = statesData.map((state) => ({
  label: state.state,
  value: state.state,
  abbr: state.stateABBR,
  text: state.state,
}));

export const stateOptions = stateAndRegionOptions.slice(0, 50);

export const stateNamesByCode: Readonly<Record<string, string>> = Object.freeze(
  statesData.reduce(
    (acc, { stateABBR, state }) => {
      acc[stateABBR] = state;
      return acc;
    },
    {} as Record<string, string>
  )
);

export const stateCodesByName: Readonly<Record<string, string>> = Object.freeze(
  statesData.reduce(
    (acc, { stateABBR, state }) => {
      acc[state.toUpperCase()] = stateABBR;
      return acc;
    },
    {} as Record<string, string>
  )
);
